import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TeeShirtIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1.10204 3.89805L2.53564 2.46445C3.38454 1.61555 4.50726 1.10342 5.69621 1.01405C5.86306 1.00151 5.99782 1.13817 6.02301 1.30359C6.16928 2.26408 6.99876 2.99998 8.00011 2.99998C9.00147 2.99998 9.83094 2.26408 9.97721 1.30359C10.0024 1.13817 10.1372 1.00151 10.304 1.01405C11.493 1.10342 12.6157 1.61555 13.4646 2.46445L14.8982 3.89805C14.9591 3.95893 14.9741 4.05192 14.9356 4.12892L13.6242 6.75179C13.5632 6.87389 13.4004 6.9003 13.3039 6.80377L12.1708 5.67069C12.1078 5.6077 12.0001 5.65231 12.0001 5.74141V14.2893C12.0001 14.4131 11.9158 14.5211 11.7957 14.5511C9.30366 15.1741 6.69656 15.1741 4.20449 14.5511C4.08438 14.5211 4.00011 14.4131 4.00011 14.2893V5.74141C4.00011 5.65232 3.8924 5.6077 3.8294 5.67069L2.69632 6.80377C2.59979 6.9003 2.43707 6.87389 2.37602 6.75179L1.06458 4.12892C1.02608 4.05192 1.04117 3.95893 1.10204 3.89805Z"
		/>
	</svg>
))
